import { CoreAPI, createCommonPriceMethods } from '@hero/sdk-core';

export function createPriceAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonPriceMethods(coreAPI),
  };
}
